import cn from 'classnames'
import { isValidElement, memo } from 'react'

import { isItem } from '../../helpers'
import { TabsProps } from '../../models'
import { ItemProps } from '../item'

import styles from './Content.module.scss'

export interface IContentProps extends Pick<TabsProps, 'classes' | 'keepMounted'> {
  items: React.ReactElement<ItemProps, string | React.JSXElementConstructor<ItemProps>>[]
  sharedBlock: React.ReactNode[]
  activeIndex: number
}

export const Content = memo<IContentProps>(
  ({ classes, keepMounted, activeIndex, items, sharedBlock }) => {
    return (
      <div className={cn(styles.content, classes?.content)}>
        <div className={styles.shared}>{sharedBlock}</div>
        {keepMounted &&
          items.map((child, index) => {
            if (isItem(child)) {
              return (
                <div
                  key={index}
                  style={{
                    height: '100%',
                    display: index === activeIndex ? 'block' : 'none',
                  }}
                >
                  {child}
                </div>
              )
            }
            return null
          })}
        {!keepMounted && isValidElement(items[activeIndex]) ? items[activeIndex] : null}
      </div>
    )
  }
)

Content.displayName = 'Content'
